import React, { useEffect } from "react";
import { Typography, Table } from "components";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../routes/routePaths";
import newTerminalImg from "../../../assets/images/new-terminal.png";
// import swapTerminalImg from "../../../assets/images/swap-terminal.png";
import "./style.scss";
import { hasPermission } from "utils/helper";
import { useSelector, useDispatch } from "react-redux";
import { permissions } from "utils/permissions";
import { getTerminals } from "redux/actions/terminalAction";
// import {terminalData as data}  from 'data'

const columns = [
  {
    Header: "S/N",
    accessor: "s/n",
    Cell: (row) => Number(row.row.id) + 1,
  },
  {
    Header: "PM Number",
    accessor: "pmNumber",
    Cell: ({ row }) => row.original.pmNumber[0] || "-",
  },
  {
    Header: "Serial Number",
    accessor: "serialNumber",
  },
  {
    Header: "Terminal ID",
    accessor: "terminalId",
  },
  {
    Header: "State",
    accessor: "state",
  },
  {
    Header: "Status",
    accessor: "status",
  },
];

const Terminals = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  /**
   *
   */
  const { user, terminals } = useSelector((state) => ({
    user: state.user.user,
    terminals: state.terminalReducer.terminals,
  }));

  const userAuthorities = user?.authorities;

  /**
   *
   */
  useEffect(() => {
    const requestParams = {
      agentId: user?.agent_id,
      // status: "ENABLED",
      size: 50,
    };
    dispatch(getTerminals(requestParams));
  }, [dispatch, user?.agent_id]);

  return (
    <div className="terminals-container bg-light">
      <div className="terminals-container-sub">
        <div className="px-4 terminal-actions-wrapper">
          <Typography variant="heading3" component="h4" state="primary">
            Terminals
          </Typography>
          <div className="mt-4 ">
            <div className="terminal-actions-container">
              <div className="d-flex flex-column flex-lg-row">
                {hasPermission(
                  permissions.canRequestForTerminals,
                  userAuthorities
                ) && (
                  <div
                    className="terminal-request-link d-flex align-items-center"
                    onClick={() => navigate(ROUTES.requestTerminal)}
                  >
                    <img src={newTerminalImg} alt="" />
                    <div className="mx-3">
                      <Typography variant="body0">
                        Request new Terminal
                      </Typography>
                      <Typography variant="body3" state="grey">
                        Request for an additional terminal.
                      </Typography>
                    </div>
                  </div>
                )}
                {/* {hasPermission(
                  permissions.canRequestForTerminals,
                  userAuthorities
                ) && (
                  <div
                    className="d-flex align-items-center swap-terminal-link"
                    onClick={() => navigate(ROUTES.swapTerminal)}
                  >
                    <img src={swapTerminalImg} alt="" />
                    <div className="mx-3">
                      <Typography variant="body0">Swap a Terminal</Typography>
                      <Typography variant="body3" state="grey">
                        Get a replacement for a faulty POS terminal.
                      </Typography>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 px-4">
          <>
            <Typography
              variant="subtitle3"
              state="primary"
              style={{ marginBottom: "1rem" }}
            >
              Assigned Terminals
            </Typography>
            <Table columns={columns} data={terminals} centerData />
          </>
        </div>
      </div>
    </div>
  );
};

export default Terminals;
